import React, { ReactNode } from 'react';
import styles from './index.less';
import classNames from 'classnames';
import { NavLink } from 'umi';

interface LogoAndTitleProps {
  logo?: ReactNode,
  titleClassName?: string
  containerClassName?: string
  onlyLogo?: boolean
}

const LogoAndTitle: React.FC<LogoAndTitleProps> = ({
                                                     onlyLogo,
                                                     logo = <img style={{ height: 30 }} src={'/logo.svg'} alt="" />,
                                                     logoWithType = <img style={{ height: 50 }}
                                                                         src={'/logo_with_type.png'} alt="" />,
                                                     titleClassName = '',
                                                     containerClassName,
                                                   }: LogoAndTitleProps) => {

  return (
    <NavLink to={'/'}>
      <div className={classNames(styles.logoAndTitle, containerClassName)}>
      <span className={styles.logo}>
        {onlyLogo ? logo : logoWithType}
      </span>
      </div>
    </NavLink>
  );
};

export default React.memo(LogoAndTitle);
